/** Import modules */

import { useTranslation }   from "react-i18next";

import { useLocation, useParams } from "react-router-dom";

import { useRef, useState, useEffect } from "react";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../../Components/SEO/localizedMeta";

import { getRobotsDirective } from "../../../Configs/LanguageConfig";

import { buildCategoryPath } from "../../../Misc/Permalinks";

/** Import models */

import Collection           from "../../../Models/BatteriesCollection";

/** Import hooks */

import Display              from "../../../Hooks/ProductDisplay";

import usePosition          from "../../../Hooks/usePosition";

/** Import components */

import Breadcrumbs          from "../../../Components/Layout/Header/Breadcrumbs";

import ComponentLoader      from "../../../Components/Layout/Loaders/Loader";

import BatteriesLayout           from "../../../Components/Products/Batteries/Catalog/Layout";

import Actions              from "../../../Components/Products/Batteries/Catalog/Actions";

import Products             from "../../../Components/Products/Batteries/Catalog/Collection";

import Pagination           from "../../../Components/Products/Batteries/Catalog/Pagination";

import NoProductsFound      from "../../../Components/Products/Shared/Catalog/NoProductsFound";

import { gql } from "@apollo/client";

import { useQuery } from "@apollo/client";

const VISUAL_MARKUP_QUERY = gql`query {

    visualMarkup {

        markupPercent

    }

}`;


/**
 * 
 * @returns Batteries product catalog page
 * 
 */

const BatteriesCatalog = () => { 
    
    const { loading: visualMarkupLoading, data: visualMarkupData } = useQuery ( VISUAL_MARKUP_QUERY );

    const 

    location                = useLocation (),

    { loading, data }       = Collection ( useParams ().parameters ),
    
    { t, i18n }             = useTranslation (),

    currentLanguage         = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    categoryPath            = buildCategoryPath ( "battery" ),

    hasNonLanguageQuery     = [ ...new URLSearchParams ( location.search ).keys () ].some ( key => key !== "lang" ),

    indexable               = location.pathname === categoryPath && ! hasNonLanguageQuery,

    canonicalHref           = localizedAbsoluteUrl ( categoryPath, currentLanguage ),

    alternateLinks          = hreflangLinks ( categoryPath ),

    robotsDirective         = indexable ? getRobotsDirective ( currentLanguage ) : "noindex,follow",

    pageDescription         = localizedValue({
        lv: "Akumulatoru katalogs Tireshop.lv - akumulatori vieglajam un komerctransportam ar dažādu ietilpību un jaudu. Ātra piegāde un servisa konsultācija.",
        en: "Battery catalog at Tireshop.lv - batteries for passenger and commercial vehicles with different capacities and power levels. Fast delivery and support.",
        ru: "Каталог аккумуляторов Tireshop.lv - аккумуляторы для легковых и коммерческих авто с разной емкостью и мощностью. Быстрая доставка и консультации."
    }, currentLanguage),

    { layout, setLayout }   = Display (),

    isMounted                           = useRef ( false ),

    [ notification, setNotification ]   = useState ( 0 ),

    filters                 = useRef ( null ),

    [ 
        
        mobileFilters, 
        
        setMobileFilters ]  = useState ( false ),

    /** Product loader */

    ProductCatalog = () => { if ( loading || visualMarkupLoading ) return <ComponentLoader />

        if ( ! data.multiFieldProductSearch.edges.length ) return <NoProductsFound />

        return <Products layout={ layout } products={ data.multiFieldProductSearch.edges } notice={ { view: notification, set: setNotification } } visualMarkup={ visualMarkupData?.visualMarkup } />

    };

    useEffect ( () => {

        if (isMounted.current) {
            const timer = setTimeout(() => setNotification ( "" ), 1000);
            return () => clearTimeout(timer);
          } else {

            isMounted.current = true;
          }

    }, [ notification ] );

    usePosition ();

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet defer={ false }>

            <title>{ `Tireshop.lv | ${ t ( "batteries" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <meta name="robots" content={ robotsDirective } />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "batteries" ), URI: categoryPath }

        ] } />

        <BatteriesLayout title={ t ( "batteries" ) } filters={ { view: mobileFilters, set: setMobileFilters, element: filters } }>

            <Actions layout={ { view: layout, set: setLayout } } mobile={ { view: mobileFilters, set: setMobileFilters, element: filters } } />

            <ProductCatalog />

            { ! loading && 

                <Pagination

                    pageInfo={ data.multiFieldProductSearch.pageInfo }

                    totalCount={ data.multiFieldProductSearch.totalCount }

                />

            }

        </BatteriesLayout>
        
    </div> );

}

/** Export component */
 
export default BatteriesCatalog;
